import type { Appointment, EpisodeOfCare } from "@rmh/defs";
import dayjs from "dayjs";
import { getFirstUpcomingAppointments } from "../appointments";
import {
  compareEpisodeOfCareByDate,
  sortEpisodeOfCareList,
} from "./sortEpisodeOfCare";
import {
  EpisodeOfCareStatus,
  getEpisodeOfCareStatus,
} from "./getEpisodeOfCareStatus";

export const getNextEpisodeOfCare = (episodeOfCareList: EpisodeOfCare[]) => {
  const res = [...episodeOfCareList];

  const isAllCompleted = res.every(
    (eoc) => getEpisodeOfCareStatus(eoc) === EpisodeOfCareStatus.Completed
  );

  if (isAllCompleted) {
    return sortEpisodeOfCareList(res)[0] ?? null;
  }

  res.sort((eoc1, eoc2) => {
    const [status1, status2] = [
      getEpisodeOfCareStatus(eoc1),
      getEpisodeOfCareStatus(eoc2),
    ];

    if (status1 === status2) {
      // Compare by most recent appointment for the eoc
      if (
        status1 !== EpisodeOfCareStatus.Completed &&
        status1 !== EpisodeOfCareStatus.Unknown
      ) {
        const eoc1FirstAppointment = getFirstUpcomingAppointments(
          eoc1.appointments
        ) as Appointment;

        const eoc2FirstAppointment = getFirstUpcomingAppointments(
          eoc2.appointments
        ) as Appointment;

        if (!eoc1FirstAppointment || !eoc2FirstAppointment) {
          return 0;
        }

        return dayjs(eoc1FirstAppointment.appointmentDate).isBefore(
          eoc2FirstAppointment.appointmentDate
        )
          ? -1
          : 1;
      }

      // Compare by occurred date
      return compareEpisodeOfCareByDate(eoc1, eoc2);
    }

    return status1 - status2;
  });

  return res[0];
};
